module.exports = __webpack_public_path__ + "static/img/electric-red.db7877d9.png";